// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f96386fa","703":"7dfc8b4c","787":"0616c5b3"}[chunkId] + ".chunk.js";
};